export default () => {
  const containers = document.querySelectorAll('.js-read-more')

  if (containers.length > 0) {
    ;[...containers].forEach(container => {
      const link = container.querySelector('.js-read-more__link')
      let state = container.dataset.visible === 'true'
      const onClick = () => {
        state = !state
        container.dataset.visible = state
      }

      link.onclick = onClick
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/ReadMore.js